import { motion } from "framer-motion";
import { useLanguage } from "@/hooks/useLanguage";

interface SectionHeadingProps {
  overlineKey?: string;
  titleKey?: string;
  descriptionKey?: string;
  align?: "left" | "center";
  light?: boolean;
  overline?: string;
  title?: string;
  description?: string;
}

export default function SectionHeading({
  overlineKey,
  titleKey,
  descriptionKey,
  overline,
  title,
  description,
  align = "left",
  light = false,
}: SectionHeadingProps) {
  const { t } = useLanguage();
  const alignClass = align === "center" ? "text-center" : "";
  const textColor = light ? "text-white" : "text-primary-deep";
  const descColor = light ? "text-white/70" : "text-steel";
  const overlineColor = light ? "text-gold-base" : "text-steel";

  const displayOverline = overline || (overlineKey ? t(overlineKey) : undefined);
  const displayTitle = title || (titleKey ? t(titleKey) : "");
  const displayDesc = description || (descriptionKey ? t(descriptionKey) : undefined);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, ease: [0.25, 0.46, 0.45, 0.94] }}
      className={`${alignClass} max-w-3xl ${align === "center" ? "mx-auto" : ""}`}
    >
      {displayOverline && (
        <p className={`label-overline ${overlineColor} mb-3`}>{displayOverline}</p>
      )}
      <h2
        className={`font-display font-bold text-2xl md:text-3xl lg:text-4xl ${textColor} leading-tight`}
      >
        {displayTitle}
      </h2>
      {displayDesc && (
        <p className={`mt-4 text-base md:text-lg ${descColor} leading-relaxed`}>
          {displayDesc}
        </p>
      )}
    </motion.div>
  );
}
